// @ts-nocheck
// NOTE: Ported from static/javascript/daily_deposit_detail.ts as-is.
// Incremental typing TODO: replace @ts-nocheck above with real types over time.

            (function() {
                // Load translations from Django translation-data element
                function loadTranslations() {
                    const source = document.getElementById('translation-data');
                    if (!source) return {};
                    const data = source.dataset;
                    return {
                        earningsAnalysis: data.earningsAnalysis || '',
                        interestRateTiers: data.interestRateTiers || '',
                        rateChangeHistory: data.rateChangeHistory || '',
                        productDescription: data.productDescription || '',
                        accountDetails: data.accountDetails || '',
                        earningsCalculator: data.earningsCalculator || '',
                        otherVariants: data.otherVariants || '',
                        tier: data.tier || '',
                        unlimited: data.unlimited || '',
                        amount: data.amount || '',
                        calculate: data.calculate || '',
                        depositBalance: data.depositBalance || '',
                        lastUpdated: data.lastUpdated || '',
                        minimumDepositRequired: data.minimumDepositRequired || '',
                        maximumTierBalance: data.maximumTierBalance || '',
                        goToBankWebsite: data.goToBankWebsite || '',
                        passiveBalance: data.passiveBalance || '',
                        passive: data.passive || '',
                        andAbove: data.andAbove || '',
                        previousRatesAsOf: data.previousRatesAsOf || '',
                        applicableTierRate: data.applicableTierRate || '',
                        grossDailyEarnings: data.grossDailyEarnings || '',
                        withholdingTaxDeducted: data.withholdingTaxDeducted || '',
                        netDailyEarnings: data.netDailyEarnings || '',
                        effectiveNetAnnualRate: data.effectiveNetAnnualRate || '',
                        netRateAfterTax: data.netRateAfterTax || '',
                        grossRateBeforeTax: data.grossRateBeforeTax || '',
                        netEarningsDaily: data.netEarningsDaily || '',
                        zoomOut: data.zoomOut || '',
                        zoomIn: data.zoomIn || '',
                        previousRange: data.previousRange || '',
                        nextRange: data.nextRange || '',
                        balanceEarningsChart: data.balanceEarningsChart || '',
                        taxInformation: data.taxInformation || '',
                        taxInfoTry: data.taxInfoTry || '',
                        taxInfoBono: data.taxInfoBono || '',
                        taxInfoForeign: data.taxInfoForeign || '',
                        earningsAnalysisDesc: data.earningsAnalysisDesc || '',
                        interestRateTiersDesc: data.interestRateTiersDesc || '',
                        rateChangeHistoryDesc: data.rateChangeHistoryDesc || '',
                        earningsCalculatorDesc: data.earningsCalculatorDesc || '',
                        otherVariantsDesc: data.otherVariantsDesc || '',
                        showingSubset: data.showingSubset || '',
                        invalidAmount: data.invalidAmount || '',
                        noTiers: data.noTiers || '',
                        noMatchingTier: data.noMatchingTier || '',
                        balanceLabel: data.balanceLabel || '',
                        netRateLabel: data.netRateLabel || '',
                        netEarningLabel: data.netEarningLabel || '',
                        grossRateLabel: data.grossRateLabel || '',
                        dailyLabel: data.dailyLabel || '',
                        failedToLoad: data.failedToLoad || '',
                        rateLabel: data.rateLabel || 'Rate',
                        rateRangeLabel: data.rateRangeLabel || 'Rate Range',
                    };
                }
                function replaceCountPlaceholder(template, value) {
                    if (!template) return '';
                    const strValue = String(value ?? '');
                    return template
                        .replace('%%(count)s', strValue)
                        .replace('%(count)s', strValue);
                }
                const t = loadTranslations();
                const MEDIA_BASE_URL_RAW = window.BOZON_MEDIA_URL || '/media/';
                const MEDIA_BASE_URL = MEDIA_BASE_URL_RAW.endsWith('/') ? MEDIA_BASE_URL_RAW : `${MEDIA_BASE_URL_RAW}/`;
                const buildMediaUrl = (path) => {
                    if (!path) return null;
                    const trimmed = String(path).trim();
                    if (/^(https?:)?\/\//i.test(trimmed) || trimmed.startsWith('/')) {
                        return trimmed;
                    }
                    return `${MEDIA_BASE_URL}${trimmed.replace(/^\/+/, '')}`;
                };
                const noStoreFetchOptions = {
                    cache: 'no-store',
                    headers: {
                        'Cache-Control': 'no-cache',
                    },
                };
                const sortRatesByMinBalance = (rates) => Array.isArray(rates)
                    ? [...rates].sort((a, b) => {
                        const minA = Number(a && a.min_balance);
                        const minB = Number(b && b.min_balance);
                        if (Number.isFinite(minA) && Number.isFinite(minB)) return minA - minB;
                        if (Number.isFinite(minA)) return -1;
                        if (Number.isFinite(minB)) return 1;
                        return 0;
                    })
                    : [];

                function getLocalizedCurrencyName(code, fallbackName) {
                    const locale = (document.documentElement.lang || navigator.language || 'en').toString();
                    try {
                        if (typeof Intl !== 'undefined' && typeof Intl.DisplayNames === 'function') {
                            const dn = new Intl.DisplayNames([locale], { type: 'currency' });
                            const name = dn.of(code);
                            if (name && name !== code) return name;
                        }
                    } catch (_) {}
                    return fallbackName || code;
                }

                // Load offer detail data from API
                async function loadOfferDetail() {
                    const container = document.getElementById('offer-detail-container');
                    if (!container) return null;
                    const apiUrl = container.dataset.apiUrl;
                    if (!apiUrl) return null;

                    try {
                        const response = await fetch(apiUrl, noStoreFetchOptions);
                        if (!response.ok) {
                            throw new Error(`HTTP ${response.status}`);
                        }
                        const json = await response.json();
                        if (json.success && json.data) {
                            return json.data;
                        }
                        return null;
                    } catch (error) {
                        return null;
                    }
                }

                // Load earnings curve data from API
                async function loadEarningsCurve() {
                    const container = document.getElementById('offer-detail-container');
                    if (!container) return null;
                    const apiUrl = container.dataset.earningsCurveApiUrl;
                    if (!apiUrl) return null;

                    try {
                        const response = await fetch(apiUrl, noStoreFetchOptions);
                        if (!response.ok) {
                            throw new Error(`HTTP ${response.status}`);
                        }
                        const json = await response.json();
                        if (json.success && json.data) {
                            return json.data;
                        }
                        return null;
                    } catch (error) {
                        return null;
                    }
                }

                // Render all sections from API data
                async function renderOfferDetail(data) {
                    if (!data || !data.offer) return;

                    const offer = data.offer;
                    const bank = offer.bank;
                    const product = offer.product;
                    const currency = offer.currency;
                    const rates = sortRatesByMinBalance(offer.rates);
                    offer.rates = rates;
                    const color = bank.color || '#2e1818';
                    const symbol = currency.symbol || currency.code;
                    const symbolPosition = currency.symbol_position || 'RIGHT';

                    // Update page title
                    document.title = `${bank.name} - ${product.name} (${offer.translated_offer_name || offer.offer_name})`;

                    // Render header
                    renderHeader(offer, bank, product, currency, color);
                    
                    // Load and render earnings analysis (chart) from separate API
                    const earningsCurve = await loadEarningsCurve();
                    if (earningsCurve && earningsCurve.datasets && earningsCurve.datasets.length > 0) {
                        renderEarningsAnalysis(earningsCurve, currency, color, product);
                    }

                    // Render rate tiers
                    if (rates.length > 0) {
                        renderRateTiers(rates, currency, color);
                    }

                    // Render rate history
                    if (data.rate_history_groups && data.rate_history_groups.length > 0) {
                        renderRateHistory(data.rate_history_groups, currency, data.rate_history_truncated, color);
                    }

                    // Render product description
                    if (product.description) {
                        renderProductDescription(product.description, color);
                    }

                    // Render account details sidebar
                    renderAccountDetails(offer, bank, currency, color);

                    // Render earnings calculator
                    if (rates.length > 0) {
                        renderEarningsCalculator(rates, currency, symbol, symbolPosition, color);
                    }

                    // Render other variants
                    if (data.currency_groups && data.currency_groups.length > 0) {
                        renderOtherVariants(data.currency_groups, product, color);
                    }

                    // Set up detail-data element for calculator
                    const detailData = document.getElementById('detail-data');
                    if (detailData) {
                        detailData.dataset.currencySymbol = symbol;
                        detailData.dataset.symbolPosition = symbolPosition;
                        detailData.dataset.currencyCode = currency.code;
                        detailData.dataset.productName = product.name; // For BONO detection
                        const trans = loadTranslations();
                        detailData.dataset.invalidAmount = trans.invalidAmount;
                        detailData.dataset.noTiers = trans.noTiers;
                        detailData.dataset.noMatchingTier = trans.noMatchingTier;
                    }

                    // Update back link color
                    const backLink = document.getElementById('back-link');
                    if (backLink) {
                        backLink.style.setProperty('--hover-color', color);
                        backLink.onmouseenter = function() { this.style.color = color; };
                        backLink.onmouseleave = function() { this.style.color = ''; };
                    }
                }

                // Individual render functions would go here - but given the complexity,
                // I'll create a simplified version that creates the HTML structure
                // The existing chart code will work once we set up the earnings-curve-chart-data script

                function renderHeader(offer, bank, product, currency, color) {
                    const header = document.getElementById('offer-header');
                    if (!header) return;

                    const logoUrl = bank.logo_path ? buildMediaUrl(bank.logo_path) : null;
                    const logoHtml = logoUrl 
                        ? `<img src="${logoUrl}" alt="${bank.name} logo" class="max-h-20 w-auto object-contain">`
                        : `<span class="text-xl font-bold" style="color: ${color};">${bank.name}</span>`;

                    // Keep requirement-style names as-is on detail page
                    const rawOfferName = (offer.translated_offer_name || offer.offer_name || '');
                    let badgeLabel = rawOfferName;
                    // Only uppercase plain "Welcome"; keep requirement names normal case
                    if (rawOfferName.trim().toLowerCase() === 'welcome') {
                        const pageLocale = (document.documentElement.lang || navigator.language || 'en-US');
                        badgeLabel = pageLocale.toLowerCase().startsWith('tr')
                            ? rawOfferName.toLocaleUpperCase('tr-TR')
                            : rawOfferName.toLocaleUpperCase('en-US');
                    }
                    const offerBadge = !offer.is_standard_offer 
                        ? `<span class="text-xs font-semibold px-2 py-1 rounded-full border" style="background-color: ${color}15; color: ${color}; border-color: ${color}33;">${badgeLabel}</span>`
                        : '';

                    const rateBadge = offer.net_min_rate === offer.net_max_rate
                        ? `<span class="text-xs font-semibold px-2 py-1 rounded-full border" style="background-color: ${color}15; color: ${color}; border-color: ${color}33;">${t.rateLabel}: ${offer.net_min_rate.toFixed(1)}%</span>`
                        : `<span class="text-xs font-semibold px-2 py-1 rounded-full border" style="background-color: ${color}15; color: ${color}; border-color: ${color}33;">${t.rateRangeLabel}: ${offer.net_min_rate.toFixed(1)}% - ${offer.net_max_rate.toFixed(1)}%</span>`;

                    header.innerHTML = `
                        <div class="flex flex-col sm:flex-row items-start sm:items-center">
                            <div class="flex-shrink-0 mb-4 sm:mb-0 sm:mr-6">
                                <div class="w-24 h-24 bg-gray-50 rounded-lg flex items-center justify-center border border-gray-200">
                                    ${logoHtml}
                                </div>
                            </div>
                            <div>
                                <h1 class="text-3xl font-bold" style="color: ${color};">${bank.name}</h1>
                                <h2 class="text-xl font-medium text-slate-600">${product.name}</h2>
                                <div class="flex flex-wrap gap-2 mt-3">
                                    <span class="text-xs font-bold px-2 py-1 rounded-full border" style="background-color: ${color}15; color: ${color}; border-color: ${color}33;">${currency.code}</span>
                                    ${offerBadge}
                                    ${rateBadge}
                                </div>
                            </div>
                        </div>
                    `;
                }

                function renderEarningsAnalysis(earningsCurve, currency, color, product) {
                    const section = document.getElementById('earnings-analysis-section');
                    if (!section) return;

                    // Check if this is a BONO account (from product name)
                    let isBonoAccount = false;
                    if (product && product.name) {
                        const productName = product.name.toLowerCase();
                        isBonoAccount = productName.includes('bono');
                    } else {
                        // Fallback: check detail-data element if product not provided
                        const detailData = document.getElementById('detail-data');
                        if (detailData && detailData.dataset.productName) {
                            const productName = detailData.dataset.productName.toLowerCase();
                            isBonoAccount = productName.includes('bono');
                        }
                    }
                    
                    // Select appropriate tax info based on account type
                    let taxInfo;
                    if (isBonoAccount && t.taxInfoBono) {
                        taxInfo = t.taxInfoBono;
                    } else if (currency.code === 'TRY') {
                        taxInfo = t.taxInfoTry;
                    } else {
                        taxInfo = t.taxInfoForeign;
                    }

                    section.innerHTML = `
                        <div class="bg-white shadow-lg rounded-lg border border-gray-200">
                            <div class="p-6 border-b border-gray-200">
                                <div>
                                    <h3 class="text-xl font-bold" style="color: ${color};">${t.earningsAnalysis}</h3>
                                    <p class="text-sm text-gray-500 mt-1">${t.earningsAnalysisDesc}</p>
                                </div>
                            </div>
                            <div class="p-6 space-y-4">
                                <div class="space-y-3">
                                    <div id="chart-navigation" class="flex flex-col sm:flex-row items-start sm:items-center justify-between w-full gap-3">
                                        <div class="flex items-center flex-shrink-0">
                                            <select id="chart-metric-selector" class="bg-white border border-gray-200 rounded-lg px-3 py-1.5 text-xs font-medium text-gray-700 shadow-md transition-all cursor-pointer w-full sm:w-auto focus:ring-2 focus:ring-gray-300 focus:border-gray-300">
                                                <option value="net_rate">${t.netRateAfterTax}</option>
                                                <option value="gross_rate">${t.grossRateBeforeTax}</option>
                                                <option value="net_earning">${t.netEarningsDaily}</option>
                                            </select>
                                        </div>
                                        <div class="flex items-center gap-2 flex-wrap">
                                            <div id="chart-range-indicator" class="bg-white bg-opacity-95 backdrop-blur-sm px-3 py-1.5 rounded-lg shadow-md border border-gray-200 text-xs font-medium text-gray-700 whitespace-nowrap">
                                                <span id="chart-range-text"></span>
                                            </div>
                                            <div class="flex items-center gap-1 border-l border-gray-200 pl-2">
                                                <button id="chart-zoom-out-btn" class="bg-white text-gray-700 font-semibold py-1.5 px-2 rounded-lg shadow-md border border-gray-200 hover:bg-gray-50 transition-all disabled:opacity-40 disabled:cursor-not-allowed hover:shadow-lg active:scale-95" aria-label="${t.zoomOut}">
                                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4"></path></svg>
                                                </button>
                                                <button id="chart-zoom-in-btn" class="bg-white text-gray-700 font-semibold py-1.5 px-2 rounded-lg shadow-md border border-gray-200 hover:bg-gray-50 transition-all disabled:opacity-40 disabled:cursor-not-allowed hover:shadow-lg active:scale-95" aria-label="${t.zoomIn}">
                                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path></svg>
                                                </button>
                                            </div>
                                            <div class="flex items-center gap-1 border-l border-gray-200 pl-2">
                                                <button id="chart-prev-btn" class="bg-white text-gray-700 font-semibold py-1.5 px-2.5 rounded-lg shadow-md border border-gray-200 hover:bg-gray-50 transition-all disabled:opacity-40 disabled:cursor-not-allowed hover:shadow-lg active:scale-95" aria-label="${t.previousRange}">
                                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path></svg>
                                                </button>
                                                <button id="chart-next-btn" class="bg-white text-gray-700 font-semibold py-1.5 px-2.5 rounded-lg shadow-md border border-gray-200 hover:bg-gray-50 transition-all disabled:opacity-40 disabled:cursor-not-allowed hover:shadow-lg active:scale-95" aria-label="${t.nextRange}">
                                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="relative bg-gray-50 rounded-lg p-3 border border-gray-200 w-full" style="height: 400px;">
                                        <canvas id="earnings-curve-chart" aria-label="${t.balanceEarningsChart}" role="img"></canvas>
                                    </div>
                                </div>
                                <script id="earnings-curve-chart-data" type="application/json">${JSON.stringify(earningsCurve)}</script>
                                <script id="bank-color-data" type="application/json">"${color}"</script>
                                <div class="p-3 bg-amber-50 border border-amber-200 rounded-lg mt-4">
                                    <p class="text-xs text-amber-800">
                                        <strong>${t.taxInformation}</strong> ${taxInfo}
                                    </p>
                                </div>
                            </div>
                        </div>
                    `;
                    
                    // Initialize chart after rendering HTML
                    // Wait for Chart.js to be available and DOM to be updated
                    function tryInitChart(retries = 20) {
                        if (typeof Chart !== 'undefined' && typeof window.initChart === 'function') {
                            const dataScript = document.getElementById('earnings-curve-chart-data');
                            const canvas = document.getElementById('earnings-curve-chart');
                            if (dataScript && canvas) {
                                window.initChart();
                            } else if (retries > 0) {
                                setTimeout(() => tryInitChart(retries - 1), 50);
                            }
                        } else if (retries > 0) {
                            setTimeout(() => tryInitChart(retries - 1), 50);
                        }
                    }
                    tryInitChart();
                }

                function renderRateTiers(rates, currency, color) {
                    const section = document.getElementById('rate-tiers-section');
                    if (!section || !rates || rates.length === 0) return;
                    const t = loadTranslations();
                    const locale = window.DepositFormatUtils.getLocale();
                    const symbol = currency.symbol || currency.code;
                    const symbolPos = currency.symbol_position || 'RIGHT';
                    const formatMoneyLocal = (amount) => window.DepositFormatUtils.formatMoney(Number(amount), locale, symbol, symbolPos, 0);

                    let tiersHtml = '';
                    rates.forEach((tier, index) => {
                        const minBalance = tier.min_balance || 0;
                        const maxBalance = tier.max_balance;
                        const balanceRange = maxBalance && maxBalance < 9999999990
                            ? `${formatMoneyLocal(minBalance)} - ${formatMoneyLocal(maxBalance)}`
                            : `${formatMoneyLocal(minBalance)}+`;

                        const passiveHtml = tier.passive_balance && tier.passive_balance > 0
                            ? `<div class="text-sm text-gray-700 mt-2 pt-2 border-t border-gray-100">
                                <strong class="font-semibold">${t.passiveBalance}</strong>
                                <span class="ml-1">${tier.passive_balance_type === 'PERCENTAGE' ? `${tier.passive_balance.toFixed(1)}%` : formatMoneyLocal(tier.passive_balance)}</span>
                            </div>`
                            : '';

                        tiersHtml += `
                            <div class="p-4 border border-gray-200 rounded-lg hover:border-gray-300 hover:shadow-md transition-all">
                                <div class="text-xs font-semibold mb-2" style="color: ${color};">${t.tier} ${index + 1}</div>
                                <div class="mb-2">
                                    <div class="text-sm font-semibold text-slate-700">${balanceRange}</div>
                                </div>
                                <div class="text-lg font-bold mb-1" style="color: ${color};">${tier.annual_rate.toFixed(2)}%</div>
                                ${passiveHtml}
                            </div>
                        `;
                    });

                    section.innerHTML = `
                        <div class="bg-white shadow-lg rounded-lg border border-gray-200">
                            <div class="p-6 border-b border-gray-200">
                                <h3 class="text-xl font-bold" style="color: ${color};">${t.interestRateTiers}</h3>
                                <p class="text-sm text-gray-500 mt-1">${t.interestRateTiersDesc}</p>
                            </div>
                            <div class="p-6">
                                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                    ${tiersHtml}
                                </div>
                            </div>
                        </div>
                    `;
                }

                function formatNumber(num) {
                    const locale = window.DepositFormatUtils.getLocale();
                    return new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(num);
                }

                function renderRateHistory(historyGroups, currency, truncated, color) {
                    const section = document.getElementById('rate-history-section');
                    if (!section || !historyGroups || historyGroups.length === 0) return;
                    const t = loadTranslations();
                    const locale = window.DepositFormatUtils.getLocale();
                    const symbol = currency.symbol || currency.code;
                    const symbolPosition = currency.symbol_position || 'RIGHT';
                    const formatMoneyLocal = (amount) => window.DepositFormatUtils.formatMoney(amount, locale, symbol, symbolPosition, 0);

                    let historyHtml = '';
                    historyGroups.forEach(group => {
                        let tiersHtml = '';
                        const tiersSorted = Array.isArray(group.tiers)
                            ? [...group.tiers].sort((a, b) => {
                                const minA = Number(a.min_balance);
                                const minB = Number(b.min_balance);
                                if (Number.isFinite(minA) && Number.isFinite(minB)) return minA - minB;
                                if (Number.isFinite(minA)) return -1;
                                if (Number.isFinite(minB)) return 1;
                                return 0;
                              })
                            : [];
                        tiersSorted.forEach(tier => {
                            const passiveHtml = tier.passive_balance && tier.passive_balance > 0
                                ? `<span class="text-xs">
                                    ${t.passive} ${tier.passive_balance_type === 'PERCENTAGE' ? `${tier.passive_balance.toFixed(1)}%` : `${formatNumber(tier.passive_balance)}`}
                                </span>`
                                : '<span class="text-xs text-gray-400">-</span>';

                            tiersHtml += `
                                <tr class="text-sm">
                                    <td class="px-4 py-2 text-gray-700">${formatMoneyLocal(tier.min_balance)} - ${tier.max_balance > 9999999990 ? t.andAbove : formatMoneyLocal(tier.max_balance)}</td>
                                    <td class="px-4 py-2 text-gray-900 font-bold">${tier.annual_rate.toFixed(2)}%</td>
                                    <td class="px-4 py-2 text-gray-600">${passiveHtml}</td>
                                </tr>
                            `;
                        });

                        historyHtml += `
                            <div class="border rounded-lg overflow-hidden">
                                <h4 class="text-sm font-semibold p-3 bg-gray-50 border-b" style="color: ${color};">${t.previousRatesAsOf} ${group.label}</h4>
                                <table class="min-w-full">
                                    <tbody class="divide-y divide-gray-100">${tiersHtml}</tbody>
                                </table>
                            </div>
                        `;
                    });

                    section.innerHTML = `
                        <div class="bg-white shadow-lg rounded-lg border border-gray-200">
                            <div class="p-6 border-b border-gray-200">
                                <h3 class="text-xl font-bold" style="color: ${color};">${t.rateChangeHistory}</h3>
                                <p class="text-sm text-gray-500 mt-1">${t.rateChangeHistoryDesc}</p>
                            </div>
                            <div class="space-y-4 p-6 max-h-96 overflow-y-auto">
                                ${historyHtml}
                            </div>
                        </div>
                    `;
                }

                function renderProductDescription(description, color) {
                    const section = document.getElementById('product-description-section');
                    if (!section || !description) return;
                    const t = loadTranslations();

                    section.innerHTML = `
                        <div class="bg-white shadow-lg rounded-lg p-6 border border-gray-200">
                            <h3 class="text-xl font-bold mb-4" style="color: ${color};">${t.productDescription}</h3>
                            <div class="text-base text-gray-700 max-w-none">${description.replace(/\n/g, '<br>')}</div>
                        </div>
                    `;
                }

                function renderAccountDetails(offer, bank, currency, color) {
                    const section = document.getElementById('account-details-section');
                    if (!section) return;

                    const t = loadTranslations();
                    const locale = window.DepositFormatUtils.getLocale();
                    const lastUpdated = offer.last_updated ? new Date(offer.last_updated).toLocaleString(locale, { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : 'N/A';
                    const minBalanceVal = offer.rates && offer.rates.length > 0 ? offer.rates[0].min_balance : null;
                    const maxTier = offer.rates && offer.rates.length > 0 ? offer.rates[offer.rates.length - 1] : null;
                    const symbol = currency.symbol || currency.code;
                    const symbolPosition = currency.symbol_position || 'RIGHT';
                    const minBalanceText = (minBalanceVal !== null && minBalanceVal !== undefined)
                        ? window.DepositFormatUtils.formatMoney(Number(minBalanceVal), locale, symbol, symbolPosition, 0)
                        : 'N/A';
                    const maxBalanceText = (maxTier && maxTier.max_balance < 9999999990)
                        ? window.DepositFormatUtils.formatMoney(Number(maxTier.max_balance), locale, symbol, symbolPosition, 0)
                        : t.unlimited;

                    section.innerHTML = `
                        <div class="bg-white shadow-lg rounded-lg border border-gray-200">
                            <div class="p-6 border-b border-gray-200">
                                <h3 class="text-xl font-bold" style="color: ${color};">${t.accountDetails}</h3>
                            </div>
                            <div class="p-6">
                                <ul class="space-y-4 text-sm">
                                    <li class="flex items-center">
                                        <svg class="w-5 h-5 text-gray-400 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                                        <span class="text-gray-700"><strong style="color: ${color};">${t.lastUpdated}</strong> ${lastUpdated}</span>
                                    </li>
                                    <li class="flex items-center">
                                        <svg class="w-5 h-5 text-gray-400 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2"></path></svg>
                                        <span class="text-gray-700"><strong style="color: ${color};">${t.minimumDepositRequired}</strong> ${minBalanceText}</span>
                                    </li>
                                    ${maxTier ? `<li class="flex items-center">
                                        <svg class="w-5 h-5 text-gray-400 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                                        <span class="text-gray-700"><strong style="color: ${color};">${t.maximumTierBalance}</strong> ${maxBalanceText}</span>
                                    </li>` : ''}
                                    ${bank.website_url ? `<li class="flex items-center">
                                        <svg class="w-5 h-5 text-gray-400 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path></svg>
                                        <a href="${bank.website_url}" target="_blank" rel="noopener noreferrer" class="hover:underline transition-colors" style="color: ${color};">${t.goToBankWebsite}</a>
                                    </li>` : ''}
                                </ul>
                            </div>
                        </div>
                    `;
                }

                function renderEarningsCalculator(rates, currency, symbol, symbolPosition, color) {
                    const section = document.getElementById('earnings-calculator-section');
                    if (!section || !rates || rates.length === 0) return;
                    const t = loadTranslations();

                    const symbolHtml = symbolPosition === 'LEFT'
                        ? `<span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">${symbol}</span><input type="text" id="calc-balance" class="w-full pl-8 pr-4 py-2 border border-gray-200 rounded-lg transition-all focus:ring-2 focus:ring-gray-300 focus:border-gray-300" placeholder="${t.amount}" inputmode="numeric" autocomplete="off">`
                        : `<input type="text" id="calc-balance" class="w-full pl-4 pr-8 py-2 border border-gray-200 rounded-lg transition-all focus:ring-2 focus:ring-gray-300 focus:border-gray-300" placeholder="${t.amount}" inputmode="numeric" autocomplete="off"><span class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500">${symbol}</span>`;

                    const tiersJson = JSON.stringify(rates.map(tier => ({
                        minBalance: tier.min_balance,
                        maxBalance: tier.max_balance || null,
                        annualRate: tier.annual_rate,
                        passiveBalance: tier.passive_balance || null,
                        passiveBalanceType: tier.passive_balance_type || null
                    })));

                    section.innerHTML = `
                        <div class="bg-white shadow-lg rounded-lg mt-6">
                            <div class="p-6 border-b border-gray-200">
                                <h3 class="text-xl font-bold" style="color: ${color};">${t.earningsCalculator}</h3>
                                <p class="text-sm text-gray-500 mt-1">${t.earningsCalculatorDesc}</p>
                            </div>
                            <div class="p-6">
                                <div class="space-y-4">
                                    <div>
                                        <label for="calc-balance" class="block text-sm font-medium text-gray-700 mb-2">${t.depositBalance}</label>
                                        <div class="relative">
                                            ${symbolHtml}
                                            <input type="hidden" id="calc-balance-hidden">
                                        </div>
                                        <button onclick="calculateEarnings()" class="mt-4 w-full px-4 py-2 text-white font-medium rounded-lg transition-colors" style="background-color: ${color};">${t.calculate}</button>
                                    </div>
                                    <div id="calc-results" class="space-y-3 hidden">
                                        <div class="p-4 bg-gray-50 rounded-lg">
                                            <div class="text-xs mb-1" style="color: ${color};">${t.applicableTierRate}</div>
                                            <div id="calc-tier-rate" class="text-lg font-bold text-gray-900">-</div>
                                        </div>
                                        <div class="p-4 bg-gray-50 rounded-lg">
                                            <div class="text-xs mb-1" style="color: ${color};">${t.grossDailyEarnings}</div>
                                            <div id="calc-gross" class="text-lg font-bold text-gray-900">-</div>
                                        </div>
                                        <div class="p-4 bg-gray-50 rounded-lg">
                                            <div class="text-xs mb-1" style="color: ${color};">${t.withholdingTaxDeducted}</div>
                                            <div id="calc-tax" class="text-lg font-bold text-gray-900">-</div>
                                        </div>
                                        <div class="p-4 rounded-lg border border-gray-200" style="background-color: ${color}15;">
                                            <div class="text-xs mb-1" style="color: ${color};">${t.netDailyEarnings}</div>
                                            <div id="calc-net" class="text-xl font-bold" style="color: ${color};">-</div>
                                        </div>
                                        <div class="p-4 bg-gray-50 rounded-lg">
                                            <div class="text-xs mb-1" style="color: ${color};">${t.effectiveNetAnnualRate}</div>
                                            <div id="calc-net-rate" class="text-lg font-bold text-gray-900">-</div>
                                        </div>
                                    </div>
                                    <div id="calc-error" class="hidden p-4 bg-red-50 border border-red-200 rounded-lg text-red-800 text-sm"></div>
                                </div>
                            </div>
                        </div>
                        <script id="tiers-data" type="application/json">${tiersJson}</script>
                    `;
                }

                function renderOtherVariants(currencyGroups, product, color) {
                    const section = document.getElementById('other-variants-section');
                    if (!section || !currencyGroups || currencyGroups.length === 0) return;
                    const t = loadTranslations();

                    let groupsHtml = '';
                    currencyGroups.forEach((group, groupIndex) => {
                        let offersHtml = '';
                        group.offers.forEach(offer => {
                            const hasNet = Number.isFinite(offer?.net_min_rate) && Number.isFinite(offer?.net_max_rate);
                            const min = hasNet ? offer.net_min_rate : offer.min_rate;
                            const max = hasNet ? offer.net_max_rate : offer.max_rate;
                            const rateDisplay = min === max
                                ? `${min.toFixed(2)}%`
                                : `${min.toFixed(2)}% - ${max.toFixed(2)}%`;

                            offersHtml += `
                                <li>
                                    <a href="${offer.detail_url}" class="block p-4 bg-white border-l-4 rounded-lg hover:shadow-lg transition-all group" style="border-left-color: ${color};">
                                        <div class="flex items-center justify-between">
                                            <div class="flex-1">
                                                <h5 class="font-semibold text-gray-900 mb-1 transition-colors" style="color: ${color};">${offer.translated_offer_name || offer.offer_name}</h5>
                                                <div class="text-sm text-gray-600">${rateDisplay}</div>
                                            </div>
                                            <div class="ml-4 p-2 rounded-full transition-all" style="background-color: ${color}15;">
                                                <svg class="w-5 h-5" style="color: ${color};" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                                                </svg>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            `;
                        });

                        const subsetMsg = group.has_more_offers 
                            ? replaceCountPlaceholder(t.showingSubset, group.total_offers)
                            : '';

                        const localizedName = group.currency_name || '';
                        groupsHtml += `
                            <div>
                                <h4 class="text-sm font-semibold text-gray-700 mb-3">${localizedName || ''} (${group.currency_code})</h4>
                                <ul class="space-y-3">${offersHtml}</ul>
                                ${subsetMsg ? `<p class="mt-2 text-xs text-gray-500">${subsetMsg}</p>` : ''}
                            </div>
                            ${groupIndex < currencyGroups.length - 1 ? '<div class="border-t border-gray-200 mt-6"></div>' : ''}
                        `;
                    });

                    section.innerHTML = `
                        <div class="bg-white shadow-lg rounded-lg mt-6 border border-gray-200">
                            <div class="p-6 border-b border-gray-200">
                                <h3 class="text-xl font-bold" style="color: ${color};">${t.otherVariants}</h3>
                                <p class="text-sm text-gray-500 mt-1">${t.otherVariantsDesc}</p>
                            </div>
                            <div class="p-6">
                                <div class="space-y-6">${groupsHtml}</div>
                            </div>
                        </div>
                    `;
                }

                // Initialize: Load data and render
                async function initializeOfferDetail() {
                    const data = await loadOfferDetail();
                    if (data) {
                        await renderOfferDetail(data);
                        // Initialize existing functionality after rendering
                        if (document.readyState === 'loading') {
                            document.addEventListener('DOMContentLoaded', init);
                        } else {
                            init();
                        }
                    } else {
                        const header = document.getElementById('offer-header');
                        if (header) {
                            const t = loadTranslations();
                            header.innerHTML = `<div class="text-center py-8"><p class="text-sm text-red-500">${t.failedToLoad}</p></div>`;
                        }
                    }
                }

                // Start loading
                if (document.readyState === 'loading') {
                    document.addEventListener('DOMContentLoaded', initializeOfferDetail);
                } else {
                    initializeOfferDetail();
                }

                if (!window.DepositFormatUtils) {
                    window.DepositFormatUtils = {
                        getLocale: () => document.documentElement.lang || navigator.language || 'en-US',
                        formatMoney: (amount, locale, currencySymbol, symbolPosition, fractionDigits = 2) => {
                            if (!Number.isFinite(amount)) return '-';
                            const formatted = amount.toLocaleString(locale, {
                                minimumFractionDigits: fractionDigits,
                                maximumFractionDigits: fractionDigits
                            });
                            if (!currencySymbol) return formatted;
                            return symbolPosition === 'RIGHT' 
                                ? `${formatted}${currencySymbol}`
                                : `${currencySymbol}${formatted}`;
                        },
                        formatPercent: (value, locale) => {
                            if (!Number.isFinite(value)) return '-';
                            const formatted = value.toLocaleString(locale, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            });
                            return `${formatted}%`;
                        },
                        formatNumberWithCommas: (value, locale) => {
                            if (!value && value !== 0) return '';
                            const numValue = parseInt(value, 10);
                            if (!Number.isFinite(numValue)) return '';
                            return new Intl.NumberFormat(locale, {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                                useGrouping: true
                            }).format(numValue);
                        },
                        usesCommaDecimal: (locale) => {
                            const testNumber = 1234.56;
                            const formatted = new Intl.NumberFormat(locale, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }).format(testNumber);
                            return /,\d/.test(formatted);
                        },
                        getNumericValue: (value, locale) => {
                            if (!value) return '';
                            const usesComma = window.DepositFormatUtils.usesCommaDecimal(locale);
                            let cleaned = value.toString().trim();
                            if (usesComma) {
                                cleaned = cleaned.replace(/\./g, '').replace(/,/g, '');
                            } else {
                                cleaned = cleaned.replace(/,/g, '').replace(/\./g, '');
                            }
                            return cleaned.replace(/[^\d]/g, '');
                        }
                    };
                }

                function init() {
                    const detailData = document.getElementById('detail-data');
                    const currencySymbol = detailData ? detailData.dataset.currencySymbol || '' : '';
                    const symbolPosition = detailData ? detailData.dataset.symbolPosition || '' : '';
                    const currencyCode = detailData ? detailData.dataset.currencyCode || '' : '';
                    // Check if this is a BONO account - get product name from data attribute or script tag
                    let productName = '';
                    if (detailData && detailData.dataset.productName) {
                        productName = detailData.dataset.productName.toLowerCase();
                    } else {
                        // Try to get from offer data script
                        const offerScript = document.getElementById('offer-data');
                        if (offerScript) {
                            try {
                                const offerData = JSON.parse(offerScript.textContent);
                                if (offerData && offerData.offer && offerData.offer.product && offerData.offer.product.name) {
                                    productName = offerData.offer.product.name.toLowerCase();
                                }
                            } catch (e) {
                            }
                        }
                    }
                    const isBonoAccount = productName.includes('bono');
                    const TAX_RATES_CALC = {
                        'TRY': 0.175,
                        'BONO': 0.15,
                        'OTHERS': 0.25
                    };
                    const taxRate = isBonoAccount ? TAX_RATES_CALC['BONO'] : 
                                   (currencyCode === 'TRY' ? TAX_RATES_CALC['TRY'] : TAX_RATES_CALC['OTHERS']);
                    const calcLocale = window.DepositFormatUtils.getLocale();
                    
                    function loadTiers() {
                        const tiersScript = document.getElementById('tiers-data');
                        if (!tiersScript) return [];
                        try {
                            const tiersData = JSON.parse(tiersScript.textContent.trim());
                            if (!Array.isArray(tiersData)) return [];
                            return tiersData.map(tier => ({
                                ...tier,
                                maxBalance: tier.maxBalance || Infinity
                            })).sort((a, b) => parseFloat(a.minBalance) - parseFloat(b.minBalance));
                        } catch (e) {
                            return [];
                        }
                    }
                    
                    let tiers = loadTiers();
                    const formatMoneyLocal = (amount) => window.DepositFormatUtils.formatMoney(amount, calcLocale, currencySymbol, symbolPosition);
                    const formatPercentLocal = (value) => window.DepositFormatUtils.formatPercent(value, calcLocale);
                    const formatNumberWithCommasLocal = (value) => window.DepositFormatUtils.formatNumberWithCommas(value, calcLocale);
                    const getNumericValueLocal = (value) => window.DepositFormatUtils.getNumericValue(value, calcLocale);
                
                function findTier(balance) {
                    if (!tiers || tiers.length === 0) return null;
                    for (let tier of tiers) {
                        const minBalance = parseFloat(tier.minBalance);
                        const maxBalance = tier.maxBalance === Infinity || tier.maxBalance > 9999999990 ? Infinity : parseFloat(tier.maxBalance);
                        if (balance >= minBalance && (maxBalance === Infinity || balance <= maxBalance)) {
                            return tier;
                        }
                    }
                    return null;
                }
                
                window.calculateEarnings = function() {
                    tiers = loadTiers();
                    const balanceInput = document.getElementById('calc-balance');
                    const balanceHidden = document.getElementById('calc-balance-hidden');
                    const balance = parseFloat(balanceHidden?.value || getNumericValueLocal(balanceInput?.value || '') || 0);
                    const resultsDiv = document.getElementById('calc-results');
                    const errorDiv = document.getElementById('calc-error');
                    
                    resultsDiv?.classList.add('hidden');
                    errorDiv?.classList.add('hidden');
                    
                    const detailData = document.getElementById('detail-data');
                    const trans = loadTranslations();
                    const invalidAmountMsg = detailData ? detailData.dataset.invalidAmount || trans.invalidAmount : trans.invalidAmount;
                    const noTiersMsg = detailData ? detailData.dataset.noTiers || trans.noTiers : trans.noTiers;
                    const noMatchingTierMsg = detailData ? detailData.dataset.noMatchingTier || trans.noMatchingTier : trans.noMatchingTier;
                    
                    if (!balance || balance < 0) {
                        errorDiv.textContent = invalidAmountMsg;
                        errorDiv.classList.remove('hidden');
                        return;
                    }
                    
                    if (!tiers || tiers.length === 0) {
                        errorDiv.textContent = noTiersMsg;
                        errorDiv.classList.remove('hidden');
                        return;
                    }
                    
                    const tier = findTier(balance);
                    if (!tier) {
                        errorDiv.textContent = noMatchingTierMsg;
                        errorDiv.classList.remove('hidden');
                        return;
                    }
                    
                    let passiveAmount = 0;
                    if (tier.passiveBalance && tier.passiveBalanceType) {
                        if (tier.passiveBalanceType === 'PERCENTAGE') {
                            passiveAmount = balance * (tier.passiveBalance / 100);
                        } else if (tier.passiveBalanceType === 'FIXED_AMOUNT') {
                            passiveAmount = tier.passiveBalance;
                        }
                        if (passiveAmount > balance) {
                            passiveAmount = balance;
                        }
                    }
                    
                    const interestBase = Math.max(0, balance - passiveAmount);
                    const grossAnnualEarning = (interestBase * tier.annualRate) / 100;
                    const grossDailyEarning = grossAnnualEarning / 365;
                    const taxAmountDaily = grossDailyEarning * taxRate;
                    const netDailyEarning = grossDailyEarning - taxAmountDaily;
                    const netAnnualEarning = grossAnnualEarning - (grossAnnualEarning * taxRate);
                    const effectiveNetRate = balance > 0 ? (netAnnualEarning / balance) * 100 : 0;
                    
                    document.getElementById('calc-tier-rate').textContent = formatPercentLocal(tier.annualRate);
                    document.getElementById('calc-gross').textContent = formatMoneyLocal(grossDailyEarning);
                    document.getElementById('calc-tax').textContent = formatMoneyLocal(taxAmountDaily);
                    document.getElementById('calc-net').textContent = formatMoneyLocal(netDailyEarning);
                    document.getElementById('calc-net-rate').textContent = formatPercentLocal(effectiveNetRate);
                    
                    resultsDiv.classList.remove('hidden');
                };
                
                    const balanceInput = document.getElementById('calc-balance');
                    const balanceHidden = document.getElementById('calc-balance-hidden');
                    
                    if (balanceInput && balanceHidden) {
                        const maxAmount = 999999999;
                        
                        balanceInput.addEventListener('keydown', function(e) {
                            if ([8, 9, 27, 13, 46, 37, 38, 39, 40].indexOf(e.keyCode) !== -1 ||
                                (e.keyCode === 65 && e.ctrlKey === true) ||
                                (e.keyCode === 67 && e.ctrlKey === true) ||
                                (e.keyCode === 86 && e.ctrlKey === true) ||
                                (e.keyCode === 88 && e.ctrlKey === true) ||
                                (e.keyCode >= 35 && e.keyCode <= 40)) {
                                return;
                            }
                            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                                e.preventDefault();
                            }
                        });
                        
                        balanceInput.addEventListener('input', function(e) {
                            const cursorPosition = e.target.selectionStart;
                            const inputValue = e.target.value;
                            const numericValueStr = getNumericValueLocal(inputValue);
                            let numericValue = numericValueStr ? parseInt(numericValueStr, 10) : null;
                            
                            if (numericValue !== null && Number.isFinite(numericValue)) {
                                if (numericValue > maxAmount) {
                                    numericValue = maxAmount;
                                }
                                
                                balanceHidden.value = numericValue;
                                const formatted = formatNumberWithCommasLocal(numericValue);
                                e.target.value = formatted;
                                
                                const oldLength = inputValue.length;
                                const newLength = formatted.length;
                                const lengthDiff = newLength - oldLength;
                                let newCursorPosition = Math.max(0, Math.min(cursorPosition + lengthDiff, formatted.length));
                                e.target.setSelectionRange(newCursorPosition, newCursorPosition);
                            } else if (!inputValue.trim()) {
                                balanceHidden.value = '';
                                e.target.value = '';
                            }
                        });
                        
                        balanceInput.addEventListener('blur', function(e) {
                            const numericValueStr = getNumericValueLocal(e.target.value);
                            if (numericValueStr) {
                                let numericValue = parseInt(numericValueStr, 10);
                                if (numericValue !== null && Number.isFinite(numericValue)) {
                                    if (numericValue > maxAmount) {
                                        numericValue = maxAmount;
                                    }
                                    e.target.value = formatNumberWithCommasLocal(numericValue);
                                    balanceHidden.value = numericValue;
                                }
                            }
                        });
                        
                        balanceInput.addEventListener('paste', function(e) {
                            e.preventDefault();
                            const pastedText = (e.clipboardData || window.clipboardData).getData('text');
                            const numericValueStr = getNumericValueLocal(pastedText);
                            let numericValue = numericValueStr ? parseInt(numericValueStr, 10) : null;
                            
                            if (numericValue !== null && Number.isFinite(numericValue)) {
                                if (numericValue > maxAmount) {
                                    numericValue = maxAmount;
                                }
                                balanceHidden.value = numericValue;
                                e.target.value = formatNumberWithCommasLocal(numericValue);
                            } else {
                                e.target.value = '';
                                balanceHidden.value = '';
                            }
                        });
                        
                        balanceInput.addEventListener('focus', function(e) {
                            e.target.value = '';
                            balanceHidden.value = '';
                        });
                        
                        balanceInput.addEventListener('keypress', function(e) {
                            if (e.key === 'Enter') {
                                calculateEarnings();
                            }
                        });
                    }
                }
                
                if (document.readyState === 'loading') {
                    document.addEventListener('DOMContentLoaded', init);
                } else {
                    init();
                }
            })();
    (function() {
        window.DepositFormatUtils = window.DepositFormatUtils || {
            getLocale: () => document.documentElement.lang || navigator.language || 'en-US',
            
            formatMoney: (amount, locale, currencySymbol, symbolPosition, fractionDigits = 2) => {
                if (!Number.isFinite(amount)) return '-';
                const formatted = amount.toLocaleString(locale, {
                    minimumFractionDigits: fractionDigits,
                    maximumFractionDigits: fractionDigits
                });
                if (!currencySymbol) return formatted;
                return symbolPosition === 'RIGHT' 
                    ? `${formatted}${currencySymbol}`
                    : `${currencySymbol}${formatted}`;
            },
            
            formatPercent: (value, locale) => {
                if (!Number.isFinite(value)) return '-';
                const formatted = value.toLocaleString(locale, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
                return `${formatted}%`;
            },
            
            formatNumberWithCommas: (value, locale) => {
                if (!value && value !== 0) return '';
                const numValue = parseInt(value, 10);
                if (!Number.isFinite(numValue)) return '';
                return new Intl.NumberFormat(locale, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                    useGrouping: true
                }).format(numValue);
            },
            
            usesCommaDecimal: (locale) => {
                const testNumber = 1234.56;
                const formatted = new Intl.NumberFormat(locale, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(testNumber);
                return /,\d/.test(formatted);
            },
            
            getNumericValue: (value, locale) => {
                if (!value) return '';
                const usesComma = window.DepositFormatUtils.usesCommaDecimal(locale);
                let cleaned = value.toString().trim();
                if (usesComma) {
                    cleaned = cleaned.replace(/\./g, '').replace(/,/g, '');
                } else {
                    cleaned = cleaned.replace(/,/g, '').replace(/\./g, '');
                }
                return cleaned.replace(/[^\d]/g, '');
            }
        };
    })();
    
    // Load Chart.js library first
    (function() {
        // Only load Chart.js if not already loaded
        if (typeof Chart !== 'undefined') {
            return;
        }
        
        const chartScript = document.createElement('script');
        chartScript.src = 'https://cdn.jsdelivr.net/npm/chart.js@4.4.6/dist/chart.umd.min.js';
        chartScript.async = false;
        chartScript.defer = false;
        
        chartScript.onerror = function() {
        };
        
        document.head.appendChild(chartScript);
    })();
    
    // Chart initialization - expose globally so it can be called after dynamic rendering
    let chartInstance = null;  // Store chart instance globally
    
    window.initChart = function() {
            if (typeof Chart === 'undefined') {
                // If Chart.js isn't loaded yet, wait a bit and try again
                setTimeout(window.initChart, 100);
                return;
            }
            
            // Destroy existing chart instance if it exists
            if (chartInstance) {
                try {
                    chartInstance.destroy();
                } catch (e) {
                }
                chartInstance = null;
            }
            
            const detailData = document.getElementById('detail-data');
            const dataScript = document.getElementById('earnings-curve-chart-data');
            const canvas = document.getElementById('earnings-curve-chart');
            if (!dataScript || !canvas) return;
            const context2d = canvas.getContext('2d');
            if (!context2d) return;
            let payload;
            try {
                payload = JSON.parse(dataScript.textContent);
            } catch (error) {
                return;
            }
            if (!payload || !Array.isArray(payload.datasets) || payload.datasets.length === 0) return;

            const currencySymbol = payload.symbol || payload.currency || '';
            const symbolPosition = (payload.symbolPosition || 'LEFT').toUpperCase();
            const currencyCode = payload.currency || '';
            function loadTranslationsForChart() {
                const source = document.getElementById('translation-data');
                if (!source) return {};
                const data = source.dataset;
                return {
                    balanceLabel: data.balanceLabel || 'Balance',
                    netRateLabel: data.netRateLabel || 'Net Rate',
                    netEarningLabel: data.netEarningLabel || 'Net Earning',
                    grossRateLabel: data.grossRateLabel || 'Gross Rate',
                    dailyLabel: data.dailyLabel || 'Daily',
                };
            }
            const chartTrans = loadTranslationsForChart();
            const balanceLabel = chartTrans.balanceLabel;
            const netRateLabel = chartTrans.netRateLabel;
            const netEarningLabel = chartTrans.netEarningLabel;
            const grossRateLabel = chartTrans.grossRateLabel;
            
            let bankColor = '#2e1818';
            const bankColorScript = document.getElementById('bank-color-data');
            if (bankColorScript) {
                try {
                    bankColor = JSON.parse(bankColorScript.textContent);
                } catch (e) {
                }
            }
            
            const locale = window.DepositFormatUtils.getLocale();
            const TAX_RATES = {
                'TRY': 0.175,
                'BONO': 0.15,
                'OTHERS': 0.25
            };
            // Check if this is a BONO account - get product name from detail-data element
            let isBonoAccount = false;
            const detailDataForChart = document.getElementById('detail-data');
            if (detailDataForChart && detailDataForChart.dataset.productName) {
                const productName = detailDataForChart.dataset.productName.toLowerCase();
                isBonoAccount = productName.includes('bono');
            }
            const taxRate = isBonoAccount ? TAX_RATES['BONO'] : (TAX_RATES[currencyCode] || TAX_RATES['OTHERS']);
            let selectedMetric = 'net_rate';

            const formatMoneyChart = (value, fractionDigits = 0) => {
                return window.DepositFormatUtils.formatMoney(value, locale, currencySymbol, symbolPosition, fractionDigits);
            };
            
            const formatPercentChart = (value) => {
                return window.DepositFormatUtils.formatPercent(value, locale);
            };

            const calculateYValue = (balance, grossEarnings) => {
                const netEarningsAnnual = grossEarnings * (1 - taxRate);
                
                switch(selectedMetric) {
                    case 'net_earning':
                        return netEarningsAnnual / 365;
                    case 'gross_rate':
                        return balance > 0 ? (grossEarnings / balance) * 100 : 0;
                    case 'net_rate':
                    default:
                        return balance > 0 ? (netEarningsAnnual / balance) * 100 : 0;
                }
            };

            const generateContinuousPoints = (points) => {
                if (points.length < 2) {
                    return points.map(p => {
                        const balance = Number(p.balance);
                        const grossEarnings = Number(p.earnings);
                        const yValue = calculateYValue(balance, grossEarnings);
                        return { x: balance, y: yValue };
                    });
                }

                const sortedPoints = [...points].sort((a, b) => a.balance - b.balance);
                const segments = [];
                for (let i = 0; i < sortedPoints.length - 1; i++) {
                    const p1 = sortedPoints[i];
                    const p2 = sortedPoints[i + 1];
                    
                    const balance1 = Number(p1.balance);
                    const earnings1 = Number(p1.earnings);
                    const passive1 = Number(p1.passive || 0);
                    
                    let annualRate = Number(p1.annualRate || p1.annual_rate || 0);
                    if (!annualRate || annualRate === 0) {
                        const interestBase1 = Math.max(0, balance1 - passive1);
                        annualRate = interestBase1 > 0 ? (earnings1 * 100) / interestBase1 : 0;
                    }
                    
                    segments.push({
                        minBalance: balance1,
                        maxBalance: Number(p2.balance),
                        minPassive: passive1,
                        maxPassive: Number(p2.passive || 0),
                        balanceRange: Number(p2.balance) - balance1,
                        annualRate: annualRate,
                    });
                }

                const continuousPoints = [];
                const pointMap = new Map();
                
                sortedPoints.forEach(point => {
                    const balance = Number(point.balance);
                    const grossEarnings = Number(point.earnings);
                    const yValue = calculateYValue(balance, grossEarnings);
                    
                    continuousPoints.push({ x: balance, y: yValue });
                    pointMap.set(Math.round(balance), yValue);
                });
                
                for (let i = 0; i < sortedPoints.length; i++) {
                    const point = sortedPoints[i];
                    const balance = Number(point.balance);
                    const epsilon = 1;
                    
                    if (i > 0) {
                        const prevBalance = balance - epsilon;
                        const prevSeg = segments[i - 1];
                        if (prevSeg && !pointMap.has(Math.round(prevBalance))) {
                            const segmentT = (prevBalance - prevSeg.minBalance) / prevSeg.balanceRange;
                            const passive = prevSeg.minPassive + (prevSeg.maxPassive - prevSeg.minPassive) * segmentT;
                            const interestBase = Math.max(0, prevBalance - passive);
                            const grossEarnings = (interestBase * prevSeg.annualRate) / 100;
                            const yValue = calculateYValue(prevBalance, grossEarnings);
                            continuousPoints.push({ x: prevBalance, y: yValue });
                            pointMap.set(Math.round(prevBalance), yValue);
                        }
                    }
                    
                    if (i < sortedPoints.length - 1) {
                        const nextBalance = balance + epsilon;
                        const nextSeg = segments[i];
                        if (nextSeg && !pointMap.has(Math.round(nextBalance))) {
                            const segmentT = (nextBalance - nextSeg.minBalance) / nextSeg.balanceRange;
                            const passive = nextSeg.minPassive + (nextSeg.maxPassive - nextSeg.minPassive) * segmentT;
                            const interestBase = Math.max(0, nextBalance - passive);
                            const grossEarnings = (interestBase * nextSeg.annualRate) / 100;
                            const yValue = calculateYValue(nextBalance, grossEarnings);
                            continuousPoints.push({ x: nextBalance, y: yValue });
                            pointMap.set(Math.round(nextBalance), yValue);
                        }
                    }
                }
                
                for (let segIdx = 0; segIdx < segments.length; segIdx++) {
                    const seg = segments[segIdx];
                    const numInterpolationPoints = Math.max(50, Math.min(200, Math.ceil(seg.balanceRange / 5000)));
                    
                    for (let j = 1; j < numInterpolationPoints; j++) {
                        const t = j / numInterpolationPoints;
                        const balance = seg.minBalance + (seg.balanceRange * t);
                        
                        if (pointMap.has(Math.round(balance))) continue;
                        
                        const segmentT = (balance - seg.minBalance) / seg.balanceRange;
                        const passive = seg.minPassive + (seg.maxPassive - seg.minPassive) * segmentT;
                        const interestBase = Math.max(0, balance - passive);
                        const grossEarnings = (interestBase * seg.annualRate) / 100;
                        const yValue = calculateYValue(balance, grossEarnings);
                        
                        continuousPoints.push({ x: balance, y: yValue });
                        pointMap.set(Math.round(balance), yValue);
                    }
                }
                
                continuousPoints.sort((a, b) => a.x - b.x);
                return continuousPoints;
            };

            let globalMinBalance = Infinity;
            let globalMaxBalance = 0;
            payload.datasets.forEach(dataset => {
                if (dataset.points && Array.isArray(dataset.points) && dataset.points.length > 0) {
                    dataset.points.forEach(point => {
                        const balance = Number(point.balance);
                        if (Number.isFinite(balance)) {
                            globalMinBalance = Math.min(globalMinBalance, balance);
                            globalMaxBalance = Math.max(globalMaxBalance, balance);
                        }
                    });
                }
            });

            const BASE_SEGMENT_SIZE = 500000;
            const ZOOM_LEVELS = [0.1, 0.5, 1, 2, 4, 8];
            let currentZoomLevel = 2;
            let currentSegmentIndex = 0;
            // chartInstance is declared globally above

            const getYAxisLabel = () => {
                switch(selectedMetric) {
                    case 'net_earning':
                        return netEarningLabel + ' (' + chartTrans.dailyLabel + ')';
                    case 'gross_rate':
                        return grossRateLabel + ' (%)';
                    case 'net_rate':
                    default:
                        return netRateLabel + ' (%)';
                }
            };

            const regenerateDatasets = () => {
                return payload.datasets
                    .map((dataset, index) => {
                        const points = Array.isArray(dataset.points) ? dataset.points : [];
                        const formattedPoints = points
                            .map((point) => ({
                                balance: Number(point.balance),
                                earnings: Number(point.earnings),
                                passive: Number(point.passive || 0),
                                effectiveRate: Number(point.effectiveRate || point.effective_rate || 0),
                                annualRate: Number(point.annualRate || point.annual_rate || 0),
                            }))
                            .filter((point) => Number.isFinite(point.balance) && Number.isFinite(point.earnings));

                        if (!formattedPoints.length) {
                            return null;
                        }

                        const continuousPoints = generateContinuousPoints(formattedPoints);
                        const unifiedColor = bankColor;

                        return {
                            label: dataset.label,
                            data: continuousPoints,
                            parsing: false,
                            borderColor: unifiedColor,
                            backgroundColor: unifiedColor,
                            borderWidth: 2.5,
                            fill: false,
                            pointRadius: 0,
                            pointHoverRadius: 5,
                            pointHoverBorderWidth: 0,
                            tension: 0.4,
                            cubicInterpolationMode: 'monotone',
                        };
                    })
                    .filter(Boolean);
            };

            const updateChart = () => {
                const currentSegmentSize = BASE_SEGMENT_SIZE * ZOOM_LEVELS[currentZoomLevel];
                const segmentStart = currentSegmentIndex * currentSegmentSize;
                const segmentEnd = Math.min(segmentStart + currentSegmentSize, globalMaxBalance);
                const numSegments = Math.ceil(globalMaxBalance / currentSegmentSize);
                
                const allDatasetsWithMetric = regenerateDatasets();
                const filteredDatasets = allDatasetsWithMetric.map(dataset => {
                    const filteredData = dataset.data.filter(point => 
                        point.x >= segmentStart && point.x <= segmentEnd
                    );
                    return {
                        ...dataset,
                        data: filteredData
                    };
                }).filter(dataset => dataset.data.length > 0);
                
                if (chartInstance) {
                    chartInstance.data.datasets = filteredDatasets;
                    chartInstance.options.scales.x.min = segmentStart;
                    chartInstance.options.scales.x.max = segmentEnd;
                    chartInstance.options.scales.y.title.text = getYAxisLabel();
                    chartInstance.options.scales.y.ticks.callback = (value) => {
                        if (selectedMetric === 'net_earning') {
                            return formatMoneyChart(value, 0);
                        } else {
                            return formatPercentChart(value);
                        }
                    };
                    chartInstance.update('none');
                }

                const prevBtn = document.getElementById('chart-prev-btn');
                const nextBtn = document.getElementById('chart-next-btn');
                const zoomInBtn = document.getElementById('chart-zoom-in-btn');
                const zoomOutBtn = document.getElementById('chart-zoom-out-btn');
                const rangeText = document.getElementById('chart-range-text');
                const navigation = document.getElementById('chart-navigation');

                if (prevBtn && nextBtn && zoomInBtn && zoomOutBtn && rangeText && navigation) {
                    prevBtn.disabled = currentSegmentIndex === 0;
                    nextBtn.disabled = currentSegmentIndex >= numSegments - 1;
                    zoomInBtn.disabled = currentZoomLevel >= ZOOM_LEVELS.length - 1;
                    zoomOutBtn.disabled = currentZoomLevel <= 0;
                    
                    if (navigation) {
                        navigation.style.display = 'flex';
                    }
                    if (rangeText) {
                        if (numSegments > 1 || currentZoomLevel > 0) {
                            rangeText.style.display = 'block';
                            rangeText.textContent = `${formatMoneyChart(segmentStart, 0)} - ${formatMoneyChart(segmentEnd, 0)}`;
                        } else {
                            rangeText.style.display = 'none';
                        }
                    }
                }
            };

            const initialDatasets = regenerateDatasets();
            if (!initialDatasets.length) {
                return;
            }

            // Create chart instance
            chartInstance = new Chart(context2d, {
                type: 'line',
                data: { datasets: initialDatasets },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: {
                        duration: 0,
                    },
                    transitions: {
                        active: {
                            animation: {
                                duration: 0,
                            },
                        },
                    },
                    elements: {
                        point: {
                            radius: 0,
                            hoverRadius: 5,
                        },
                        line: {
                            borderJoinStyle: 'round',
                            borderCapStyle: 'round',
                        },
                    },
                    interaction: {
                        mode: 'nearest',
                        intersect: false,
                        axis: 'x',
                    },
                    plugins: {
                        legend: {
                            display: false,
                        },
                        tooltip: {
                            enabled: true,
                            intersect: false,
                            position: 'nearest',
                            yAlign: 'top',
                            xAlign: 'center',
                            caretPadding: 10,
                            caretSize: 6,
                            cornerRadius: 6,
                            backgroundColor: 'rgba(255, 255, 255, 0.98)',
                            titleColor: '#111827',
                            bodyColor: '#111827',
                            borderColor: '#E5E7EB',
                            borderWidth: 1,
                            padding: 10,
                            displayColors: false,
                            boxPadding: 4,
                            titleFont: {
                                size: 13,
                                weight: '600',
                            },
                            bodyFont: {
                                size: 13,
                                weight: '600',
                            },
                            callbacks: {
                                title() {
                                    return '';
                                },
                                label(context) {
                                    if (!context) return '';
                                    const balance = context.parsed.x;
                                    const yValue = context.parsed.y;
                                    
                                    let labelText = '';
                                    switch(selectedMetric) {
                                        case 'net_earning':
                                            labelText = `${netEarningLabel}: ${formatMoneyChart(yValue, 2)}`;
                                            break;
                                        case 'gross_rate':
                                            labelText = `${grossRateLabel}: ${formatPercentChart(yValue)}`;
                                            break;
                                        case 'net_rate':
                                        default:
                                            labelText = `${netRateLabel}: ${formatPercentChart(yValue)}`;
                                            break;
                                    }
                                    
                                    return [
                                        `${balanceLabel}: ${formatMoneyChart(balance, 0)}`,
                                        labelText
                                    ];
                                },
                            },
                        },
                    },
                    layout: {
                        padding: {
                            top: 20,
                            right: 8,
                            bottom: 8,
                            left: 8,
                        },
                    },
                    scales: {
                        x: {
                            type: 'linear',
                            title: {
                                display: true,
                                text: currencySymbol ? `${balanceLabel} (${currencySymbol})` : balanceLabel,
                                font: {
                                    size: 11,
                                    weight: '600',
                                },
                                color: '#6B7280',
                                padding: { top: 6, bottom: 3 },
                            },
                            grid: {
                                display: true,
                                color: 'rgba(0, 0, 0, 0.03)',
                                drawBorder: true,
                                borderColor: '#E5E7EB',
                            },
                            ticks: {
                                maxTicksLimit: 6,
                                font: {
                                    size: 10,
                                },
                                color: '#9CA3AF',
                                callback: (value) => formatMoneyChart(value, 0),
                            },
                        },
                        y: {
                            title: {
                                display: true,
                                text: getYAxisLabel(),
                                font: {
                                    size: 11,
                                    weight: '600',
                                },
                                color: '#6B7280',
                                padding: { top: 3, bottom: 6, right: 6 },
                            },
                            grid: {
                                display: true,
                                color: 'rgba(0, 0, 0, 0.03)',
                                drawBorder: true,
                                borderColor: '#E5E7EB',
                            },
                            beginAtZero: true,
                            ticks: {
                                maxTicksLimit: 6,
                                font: {
                                    size: 10,
                                },
                                color: '#9CA3AF',
                                callback: (value) => {
                                    if (selectedMetric === 'net_earning') {
                                        return formatMoneyChart(value, 0);
                                    } else {
                                        return formatPercentChart(value);
                                    }
                                },
                            },
                        },
                    },
                },
            });
            
            const metricSelector = document.getElementById('chart-metric-selector');
            if (metricSelector) {
                metricSelector.addEventListener('change', (e) => {
                    selectedMetric = e.target.value;
                    updateChart();
                });
            }
            
            const prevBtn = document.getElementById('chart-prev-btn');
            const nextBtn = document.getElementById('chart-next-btn');
            const zoomInBtn = document.getElementById('chart-zoom-in-btn');
            const zoomOutBtn = document.getElementById('chart-zoom-out-btn');
            
            if (prevBtn) {
                prevBtn.addEventListener('click', () => {
                    if (currentSegmentIndex > 0) {
                        currentSegmentIndex--;
                        updateChart();
                    }
                });
            }
            
            if (nextBtn) {
                nextBtn.addEventListener('click', () => {
                    const currentSegmentSize = BASE_SEGMENT_SIZE * ZOOM_LEVELS[currentZoomLevel];
                    const numSegments = Math.ceil(globalMaxBalance / currentSegmentSize);
                    if (currentSegmentIndex < numSegments - 1) {
                        currentSegmentIndex++;
                        updateChart();
                    }
                });
            }
            
            if (zoomInBtn) {
                zoomInBtn.addEventListener('click', () => {
                    if (currentZoomLevel < ZOOM_LEVELS.length - 1) {
                        // Adjust segment index to maintain similar view when zooming
                        const oldSegmentSize = BASE_SEGMENT_SIZE * ZOOM_LEVELS[currentZoomLevel];
                        const oldSegmentStart = currentSegmentIndex * oldSegmentSize;
                        
                        currentZoomLevel++;
                        const newSegmentSize = BASE_SEGMENT_SIZE * ZOOM_LEVELS[currentZoomLevel];
                        currentSegmentIndex = Math.floor(oldSegmentStart / newSegmentSize);
                        
                        updateChart();
                    }
                });
            }
            
            if (zoomOutBtn) {
                zoomOutBtn.addEventListener('click', () => {
                    if (currentZoomLevel > 0) {
                        // Adjust segment index to maintain similar view when zooming
                        const oldSegmentSize = BASE_SEGMENT_SIZE * ZOOM_LEVELS[currentZoomLevel];
                        const oldSegmentStart = currentSegmentIndex * oldSegmentSize;
                        
                        currentZoomLevel--;
                        const newSegmentSize = BASE_SEGMENT_SIZE * ZOOM_LEVELS[currentZoomLevel];
                        currentSegmentIndex = Math.floor(oldSegmentStart / newSegmentSize);
                        
                        updateChart();
                    }
                });
            }
            
            updateChart();
        };
